<twc-popup type="primary" width="l">
    <twc-popup-content>
        <div layout="row" layout-align="center center">
            <img src="{{collageWebLogoImg}}" alt="{{'APP.ALT_LOGO' | translate}}" />
            <p class="text-align-center">{{'NAVBAR.VERSION' | translate : {version} }} </p>
        </div>
    </twc-popup-content>
</twc-popup>